import i18n from '@/i18n';
import "@/scss/main.scss";
import { watch } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
	{
		path: '/',
		component: () => import('../views/HomePage.vue'),
		meta: { titleKey: 'routerTitles.home' },
	},
	{
		path: '/contact',
		component: () => import('../views/ContactPage.vue'),
		meta: { titleKey: 'routerTitles.inquiry' },
	},
	{
		path: '/:eBrake*',
		redirect: '/'
	},
	{
		path: '/E-Brake',
		component: () => import('../views/E-Brake/E-BrakePage.vue'),
		meta: { titleKey: 'routerTitles.eBrake' },
	},
	{
		path: '/E-Brake/50-130T|35-130T|160-200T',
		redirect: '/E-Brake/35-200T'
	},
	{
		path: '/E-Brake/35-40T',
		component: () => import('../views/E-Brake/35-40T.vue'),
		meta: { titleKey: 'routerTitles.eBrake3540T' },
	},
	{
		path: '/E-Brake/35-200T',
		component: () => import('../views/E-Brake/35-200T.vue'),
		meta: { titleKey: 'routerTitles.eBrake35200T' },
	},
	{
		path: '/E-Brake/300T',
		component: () => import('../views/E-Brake/300T.vue'),
		meta: { titleKey: 'routerTitles.eBrake300T' },
	},
	{
		path: '/E-Brake/MiniCell',
		component: () => import('../views/E-Brake/MiniCell.vue'),
		meta: { titleKey: 'routerTitles.eBrakeMiniCell' },
	},
	{
		path: '/:hBrake*',
		redirect: '/'
	},
	{
		path: '/H-BrakeHD/700-1000T',
		component: () => import('../views//H-BrakeHD/700-1000T.vue'),
		meta: { titleKey: 'routerTitles.hBrakeHD7001000T' },
	},
	{
		path: '/H-iBrake',
		component: () => import('../views/H-iBrake/H-iBrakePage.vue'),
		meta: { titleKey: 'routerTitles.hIBrake' },
	},
	{
		path: '/H-iBrake/125-560T',
		component: () => import('../views/H-iBrake/125-560T.vue'),
		meta: { titleKey: 'routerTitles.hIBrake125560T' },
	},
	{
		path: '/H-iBrake/125T',
		component: () => import('../views/H-iBrake/125T.vue'),
		meta: { titleKey: 'routerTitles.hIBrake125T' },
	},
	{
		path: '/M-Shear',
		component: () => import('../views/M-Shear.vue'),
		meta: { titleKey: 'routerTitles.mShear' },
	},
	{
		path: '/MultiCell',
		component: () => import('../views/MultiCell.vue'),
		meta: { titleKey: 'routerTitles.multiCell' },
	},
	{
		path: '/Software',
		component: () => import('../views/Software/SoftwarePage.vue'),
		meta: { titleKey: 'routerTitles.software' },
	},
	{
		path: '/Software/ASC-Control',
		component: () => import('../views/Software/ASC-Control.vue'),
		meta: { titleKey: 'routerTitles.softwareASCControl' },
	},
	{
		path: '/Software/E-Control',
		component: () => import('../views/Software/E-Control.vue'),
		meta: { titleKey: 'routerTitles.softwareEControl' },
	},
	{
		path: '/Software/AutoPOL',
		component: () => import('../views/Software/AutoPOL.vue'),
		meta: { titleKey: 'routerTitles.softwareAutoPOL' },
	},
	{
		path: '/Software/RoboBend',
		component: () => import('../views/Software/RoboBend.vue'),
		meta: { titleKey: 'routerTitles.softwareRoboBend' },
	},
	{
		path: '/:rBrake*',
		redirect: '/'
	},
	{
		path: '/R-Brake/130T-3100',
		component: () => import('../views/R-Brake/130T-3100.vue'),
		meta: { titleKey: 'routerTitles.rBrake130T' },
	},
	{
		path: '/RoboMate',
		component: () => import('../views/RoboMate.vue'),
		meta: { titleKey: 'routerTitles.roboMate' },
	},
	{
		path: '/ToolMate',
		component: () => import('../views/ToolMate/ToolMatePage.vue'),
		meta: { titleKey: 'routerTitles.toolMate' },
	},
	{
		path: '/ToolMate/E-BrakeC200T',
		component: () => import('../views/ToolMate/E-BrakeC200T.vue'),
		meta: { titleKey: 'routerTitles.toolMateEBrakeC200T' },
	},
	{
		path: '/ToolMate/H-BrakeTo320T',
		component: () => import('../views/ToolMate/H-BrakeTo320T.vue'),
		meta: { titleKey: 'routerTitles.toolMateHBrakeTo320T' },
	},
	{
		path: '/settings',
		component: () => import('../views/Settings/SettingsApp.vue'),
		meta: { titleKey: 'routerTitles.settings' },
		children: [
			{
				path: '',
				component: () => import('../views/Settings/SettingsHome.vue'),
				meta: { titleKey: 'routerTitles.settings' },
			},
			{
				path: 'compatibility',
				name: 'compatibility',
				component: () => import('@/views/Settings/CompatibilityCheckPage.vue'),
				meta: { titleKey: 'routerTitles.pwaCompatibilityCheck' },
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		return { top: 0 }
	},
});

router.beforeEach(() => {
	// Mimic service worker updating on navigation for SPA
	if ('serviceWorker' in navigator && navigator.onLine) {
		navigator.serviceWorker.ready.then(worker => worker.update()).catch(() => {
			// Update checks can fail when the server is unavailable; keep using the cached app.
		});
	}
});

function updateDocumentTitle(route) {
	const title = route.meta.titleKey ? i18n.global.t(route.meta.titleKey) : (route.meta.title || '');
	document.title = (title ? title + ' | ' : '') + 'SafanDarley Kiosk';
}

router.afterEach((to) => {
	updateDocumentTitle(to);
});

// Update title when language changes
watch(() => i18n.global.locale.value, () => {
	if (router.currentRoute.value) {
		updateDocumentTitle(router.currentRoute.value);
	}
});

export default router
